import gql from 'graphql-tag';
import deviceFragment from '../fragments/device';
import eventFragment from '../fragments/event';
import deviceHistoryFragment from '../fragments/deviceHistory';
import situationFragment from '../fragments/situation';

const GET_DEVICE_HISTORY_BY_DEVICE_ID = gql`
  query getDeviceHistoryByDeviceId(
    $id: ID!
    $take: Int
    $skip: Int
    $sort: DeviceHistorySortInput
    $filter: DeviceHistoryFilterInput
  ) {
    getDeviceHistoryByDeviceId(
      id: $id
      take: $take
      skip: $skip
      sort: $sort
      filter: $filter
    ) {
      deviceHistories {
        ...deviceHistoryDetails
        eventId
        devicePosition {
          ...devicePositionDetails
        }
        situationId
      }
      aggregate {
        rows
      }
    }
  }
  ${deviceHistoryFragment.FRAGMENT_DEVICE_HISTORY}
  ${deviceFragment.FRAGMENT_DEVICE_POSITION}
`;

const GET_DEVICE_HISTORY_BY_WORKSPACE_ID_AND_WORKSPACE_TO_WORKSPACE = gql`
  query getDeviceHistoriesByWorkspaceAndWorkspaceToWorkspace(
    $workspaceId: ID!
    $take: Int
    $skip: Int
    $sort: DeviceHistorySortInput
  ) {
    getDeviceHistoriesByWorkspaceAndWorkspaceToWorkspace(
      workspaceId: $workspaceId
      take: $take
      skip: $skip
      sort: $sort
    ) {
      ...deviceHistoryDetails
      devicePosition {
        ...devicePositionDetails
      }
      situation {
        ...situationListDetails
      }
    }
  }
  ${deviceHistoryFragment.FRAGMENT_DEVICE_HISTORY}
  ${deviceFragment.FRAGMENT_DEVICE_POSITION}
  ${situationFragment.SITUATION_LIST}
`;

const GET_DEVICE_HISTORY_BY_ID = gql`
  query GetDeviceHistoryById($id: ID!) {
    getDeviceHistoryById(id: $id) {
      id
      eventId
      data
      receivedAt
      generatedAt
      isSelfGenerated
      devicePosition {
        ...devicePositionDetails
      }
      cctvRelated {
        device {
          id
          name
          config
          workspaceId
        }
        channel {
          id
          channelId
          description
        }
      }
      event {
        id
        code
        technicalDescription
        color
        priority
        eventGroup {
          id
          name
        }
      }
      device {
        id
        name
        image
        uniqueId
        workspacePrefix {
          id
          prefix
        }
      }
    }
  }
  ${deviceFragment.FRAGMENT_DEVICE_POSITION}
`;

export default {
  GET_DEVICE_HISTORY_BY_DEVICE_ID,
  GET_DEVICE_HISTORY_BY_WORKSPACE_ID_AND_WORKSPACE_TO_WORKSPACE,
  GET_DEVICE_HISTORY_BY_ID,
};
